import RootPage from "../RootPage";
import StockTransferImportFeature from "../../features/imports/stock-transfer";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import localisations from "../../shell/localisation";
import { reactPlugin } from "../../app-insights";
import { useAuth0 } from "@auth0/auth0-react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";

function StockTransferImportPage() {
    const { user } = useAuth0();

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={localisations.pages.stockTransferImport.heading}>
            <StockTransferImportFeature fieldCompanyId={fieldCompanyId} />
        </RootPage>
    );
}

export default withAITracking(reactPlugin, StockTransferImportPage, "Stock Transfer Import Page");
